import { mod10 } from "./mod10";

function leftPad(
    value: number | string,
    totalWidth: number,
    paddingChar?: string
  ) {
    var length = totalWidth - value.toString().length + 1;
    return Array(length).join(paddingChar || "0") + value;
  }
  
  //FUNCAO PARA O DIGITO VEIFICADOR MODELO 10
  
  
  
  export function geraCodigo(
    id: number,
    vencimento: Date,
    valor: number,
    codigo_municipio: string
  ) {
    //window.alert(codigo_municipio);
    codigo_municipio = codigo_municipio ? codigo_municipio : "1234"; //CASO N SEJA CADASTRADO CODIGO DE MUNICIPIO PARA TESTES
    //window.alert(`ID: ${id},vencimento:${vencimento}, valor:${valor},codigo_municipio:${codigo_municipio}  `)
  
    let ZZ;
  
    //PASSO 1 - pergar id da guia
    //window.alert(id)
    const AA = String(id);
    ZZ = leftPad(AA, 8);
    //PASSO 2 - acrescentar data de vencimento(ano, mês , dia)
  
    const PROV =
      String(vencimento.getFullYear()) +
      leftPad(vencimento.getMonth() + 1, 2) +
      leftPad(vencimento.getDate(), 2);
  
    ZZ = PROV + ZZ;
    console.log("zz->", ZZ);
    console.log();
  
    //PASSO 3 - Acrescentar valor(separar entre parte inteira e decimal)
  
    const valorEmCentavos = Math.round(valor * 100);
const parte_inteira = Math.floor(valorEmCentavos / 100);
const parte_decimal = valorEmCentavos % 100;

let YY = leftPad(parte_inteira, 9) + leftPad(parte_decimal, 2);
  
    console.log("DECU-> ", YY);
    //PASSO 4 - armazenar identificador para o tributo, no caso do ITBI usaremos como identficador de tributo a chave 71784
  
    //IDENTIDICADOS DO ISSQN
    const identificador = "7179";
    //8160000001221212342028undefined99888871780
  
    //PASSO 5 - código do múnicipio
    //na tabela FOL_PARAMET EM UM CAMPO  C_FEBRABAN , ali tem o codigo de 4 digitos que identifica de qual prefeitura e o carne
  
    //const codigo_municipio = "1234"; //select C_FEBRABAN from FOL_PARAMET;
  
    //6) montar variável
  
    const XX = YY + codigo_municipio + ZZ + "888" + "8" + identificador + "0";
    console.log("xx-> ", XX);
    // 7) meu codigo de barras vai comecar por 816  apos isso vai vir um digito verificador uso uma funcao para achar qual e o digito verificador
  
    const TESTEMOD10 = "816" + XX;
    //window.alert("Esse que gerou: "+TESTEMOD10);
    const hh = String(mod10(TESTEMOD10));
  
    // aqui estou acrescentando o digito verificador (hh) entre o 816 e o conteudo XX
  
    console.log("Este é o hh: ",hh);
    console.log(XX);
    YY = "816" + hh + XX;
    console.log("YY-> ", YY.length);
    //8) ALEM DESTE DIGITO VERIFICADOR QUE FICA APOS O 816  TEMOS QUE COLOCAR MAIS 4 DIGITOS VERIFICADORES DA SEGUINTE FORMA:
  
    const AA1 = YY.substring(0, 11);
  
     //const AA1_dig = mod10(AA1); //pp STRING QUE JA TEM UM DIGITO VERIFICADOR
  
    const AA2 = YY.substring(11, 22);
  
    //const AA2_dig = mod10(AA2);
  
    const AA3 = YY.substring(22, 33);
   // const AA3_dig = mod10(AA3);
  
    const AA4 = YY.substring(33, 44);
    //console.log(AA1)
    //console.log("AA2 ->",AA2)
    //console.log("O TRÊS-> ",AA3)
    //console.log(AA4)
  
    //const AA4_dig = mod10(AA4);
  
    //E AGORA MEU CODIGO FICA ASSIM:   11 DIGITOS + DIGITO VERIFICADOR + 11 DIGITOS +  DIGITO VERIICADOR +11 DIGITOS +  DIGITO VERIICADOR+11 DIGITOS +  DIGITO VERIICADOR
    //console.log(XX)
    
    return (
      AA1 +
     // String(AA1_dig) +
      AA2 +
     // String(AA2_dig) +
      AA3 +
     // String(AA3_dig) +
      AA4 
     // String(AA4_dig)
    );
  }